import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css, styled } from 'styled-components';
import { Paragraph, Link } from '@cof/plastic-components';

import BodySection from '../../components/BodySection';
import Footer from '../../components/Footer';
import Main from '../../components/Main';
import TitleSection, { TitleSectionHeading } from '../../components/TitleSection';
import { withText } from '../../text/textStore';
import { addNewRelicError } from '../../utilities/newRelic';

export const ErrorTitleSection = styled(TitleSection)`
    ${({ theme }: any) => css`
        ${theme.components.HeroWrapper}
    `}
`;
ErrorTitleSection.displayName = 'ErrorTitleSection';
import { useAggregatorConsumerName } from '../../utilities/aggregatorConsumerNameProvider';

const TechnicalError = ({ Text }: any) => {
    const [aggregatorConsumerName] = useAggregatorConsumerName();
    useEffect(() => {
        addNewRelicError('technical-error', { sawError: true });
    }, []);

    return (
        <>
            <Main bg="global.white" data-qa-id="technical-error-page">
                <ErrorTitleSection>
                    <TitleSectionHeading data-qm-allow>
                        <Text path="Heading" />
                    </TitleSectionHeading>
                </ErrorTitleSection>
                <BodySection>
                    <Paragraph data-qa-id="tech-error-message" data-qm-allow>
                        {aggregatorConsumerName === 'MSM' ? (
                            <Paragraph>
                                Go back to MoneySuperMarket to try again, or{' '}
                                <Link href="https://capitalone.co.uk">capitalone.co.uk</Link> to find out more about us
                                and our credit cards.
                            </Paragraph>
                        ) : (
                            <Text path="Body" params={{ 'data-qm-allow': 'true' }} />
                        )}
                    </Paragraph>
                </BodySection>
            </Main>
            <Footer />
        </>
    );
};

TechnicalError.propTypes = {
    Text: PropTypes.func.isRequired
};

const WrappedTechnicalError = withText('TechnicalError')(TechnicalError);

WrappedTechnicalError.displayName = 'TechnicalError';

export default WrappedTechnicalError;
